module.exports = __webpack_public_path__ + "static/media/bg_top.0ed769b3.svg";